import api, { API } from "./api";
import { toast } from "sonner";

export async function downloadReport(reportType, fmt, params, filename) {
  const res = await api.get(`/reports/${reportType}/export`, {
    params: { fmt, ...params }, responseType: "blob",
  });
  const ext = fmt === "excel" ? "xlsx" : "pdf";
  const url = window.URL.createObjectURL(new Blob([res.data]));
  const a = document.createElement("a");
  a.href = url; a.download = filename ? `${filename}.${ext}` : `${reportType}_report.${ext}`;
  document.body.appendChild(a); a.click(); a.remove();
  window.URL.revokeObjectURL(url);
}

export async function shareWhatsApp(reportType, params, textSummary) {
  return shareUrlWhatsApp(`/reports/${reportType}/export`, params, textSummary, `${reportType}_report.pdf`);
}

export async function downloadUrl(path, params, filename) {
  const res = await api.get(path, { params, responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([res.data]));
  const a = document.createElement("a");
  a.href = url; a.download = filename;
  document.body.appendChild(a); a.click(); a.remove();
  window.URL.revokeObjectURL(url);
}

export async function shareUrlWhatsApp(path, params, textSummary, fname) {
  try {
    const res = await api.get(path, { params: { fmt: "pdf", ...params }, responseType: "blob" });
    const file = new File([res.data], fname, { type: "application/pdf" });
    if (navigator.canShare && navigator.canShare({ files: [file] })) {
      await navigator.share({ files: [file], title: "PM POSHAN Report", text: textSummary });
      return;
    }
  } catch (e) { /* fall through to wa.me */ }
  const url = `https://wa.me/?text=${encodeURIComponent(textSummary)}`;
  window.open(url, "_blank");
}
